// Sticky inhoudsopgave voor artikelpagina. Bouwt de TOC uit de
// h2/h3-koppen in de artikeltekst, met scroll-spy (actieve kop gemarkeerd).
// H2 = hoofdkop (altijd zichtbaar), h3 = subkop (uitklapbaar per groep).
// De groep van de kop waar je in scrollt klapt uit, de rest klapt dicht.
(() => {
  const body = document.querySelector('[data-article-body]');
  const nav = document.querySelector('[data-toc]');
  const list = document.querySelector('[data-toc-list]');
  if (!body || !nav || !list) return;

  const headings = Array.from(body.querySelectorAll('h2, h3'));
  if (headings.length < 2) return;

  const slugify = (text) =>
    text.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-') || 'sectie';

  const used = new Set();
  const links = new Map();   // heading-id -> anchor
  const groupOf = new Map(); // heading-id -> group-li (h2-groep waar de kop bij hoort)
  let currentGroup = null;   // laatst gemaakte h2-groep

  const makeAnchor = (h) => {
    if (!h.id) {
      let id = slugify(h.textContent);
      let n = 2;
      while (used.has(id) || document.getElementById(id)) { id = `${slugify(h.textContent)}-${n++}`; }
      h.id = id;
    }
    used.add(h.id);
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent;
    a.className = 'toc__link';
    links.set(h.id, a);
    a.addEventListener('click', (e) => {
      e.preventDefault();
      h.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${h.id}`);
    });
    return a;
  };

  headings.forEach((h) => {
    const a = makeAnchor(h);

    if (h.tagName === 'H2') {
      const li = document.createElement('li');
      li.className = 'toc__group';
      li.appendChild(a);

      // Uitklapbaar sub-omhulsel (grid-rows animatie: ul > div > li's)
      const sub = document.createElement('ul');
      sub.className = 'toc__sublist';
      sub.setAttribute('role', 'list');
      const inner = document.createElement('div');
      sub.appendChild(inner);
      li.appendChild(sub);

      list.appendChild(li);
      currentGroup = li;
      currentGroup._inner = inner;
      groupOf.set(h.id, li);
    } else {
      a.classList.add('toc__link--sub');
      const li = document.createElement('li');
      li.appendChild(a);
      if (currentGroup) {
        currentGroup._inner.appendChild(li);
        groupOf.set(h.id, currentGroup);
      } else {
        // h3 zonder voorafgaande h2: los in de lijst
        list.appendChild(li);
      }
    }
  });

  nav.hidden = false;

  // Scroll-spy: markeer actieve kop + klap z'n groep uit
  let active = null;
  let openGroup = null;

  const openOnly = (group) => {
    if (group === openGroup) return;
    if (openGroup) openGroup.classList.remove('is-open');
    openGroup = group || null;
    if (openGroup) openGroup.classList.add('is-open');
  };

  const setActive = (id) => {
    if (id === active) return;
    if (active && links.get(active)) links.get(active).classList.remove('is-active');
    active = id;
    if (links.get(id)) links.get(id).classList.add('is-active');
    openOnly(groupOf.get(id));
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((en) => en.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length) setActive(visible[0].target.id);
    },
    { rootMargin: '-90px 0px -65% 0px', threshold: 0 }
  );

  headings.forEach((h) => observer.observe(h));
})();
